import { Box, Divider, Flex } from "flicket-ui";
import Image from "~components/common/Image";
import {
  isCompetitionPageContext,
  PageContext,
} from "~features/events/hooks/useDetailsPageContext";
import { ctaStateFromPageContext } from "~features/events/utils/pageStateFromContext";
import CompetitionDetails from "../CompetitionDetails/CompetitionDetails";
import { CTACountdown } from "../events.CTACard";
import EventCTACard from "../events.EventCTACard";
import EventInformation, { EventSummary } from "../events.EventInformation";
import { useOrganization } from "~hooks";

type MobileDetailProps = {
  pageContext: PageContext;
};

export const Mobile = ({ pageContext }: MobileDetailProps) => {
  const { event } = pageContext;
  const { title, logo } = event;
  const { hasFeature } = useOrganization();

  const { countdownTo, competitionCTACardProps } = ctaStateFromPageContext(
    pageContext
  );

  const hideCountdown =
    (hasFeature("HidePresaleCountdown") && countdownTo?.type === "presale") ||
    (hasFeature("HideMainSaleCountdown") && countdownTo?.type === "onsale");

  const hasRunningCompetition = isCompetitionPageContext(pageContext);

  return (
    <Flex flexDir="column" px={2} pb={5} overflowY="auto" flex="1">
      <Box flex="1">
        {/* Spacer */}
        <Box height={0} width={"100%"} mt={4} />

        {logo && <Image alt={title} mb={4} image={logo} />}

        <EventSummary event={event} />

        {countdownTo && !hideCountdown && (
          <CTACountdown
            pageContext={pageContext}
            countdownTo={countdownTo}
            mt={2}
          />
        )}

        {hasRunningCompetition ? (
          <EventCTACard mt={5} {...competitionCTACardProps} />
        ) : null}

        {!hasRunningCompetition && <Divider my={4} />}

        <EventInformation event={event} mb={5} />

        {hasRunningCompetition ? (
          <CompetitionDetails
            competition={pageContext.competition}
            eventId={pageContext.event?.id}
          />
        ) : null}
      </Box>
    </Flex>
  );
};
